import { CALL_API, Schemas } from '../../common/middleware/api';

export const TERM_HOLIDAY_PERIODS_REQUEST = 'TERM_HOLIDAY_PERIODS_REQUEST';
export const TERM_HOLIDAY_PERIODS_SUCCESS = 'TERM_HOLIDAY_PERIODS_SUCCESS';
export const TERM_HOLIDAY_PERIODS_FAILURE = 'TERM_HOLIDAY_PERIODS_FAILURE';

export const TERM_HOLIDAY_PERIOD_FETCH_REQUEST = 'TERM_HOLIDAY_PERIOD_GET_REQUEST';
export const TERM_HOLIDAY_PERIOD_FETCH_SUCCESS = 'TERM_HOLIDAY_PERIOD_GET_SUCCESS';
export const TERM_HOLIDAY_PERIOD_FETCH_FAILURE = 'TERM_HOLIDAY_PERIOD_GET_FAILURE';

export const TERM_HOLIDAY_PERIOD_CREATE_REQUEST = 'TERM_HOLIDAY_PERIOD_CREATE_REQUEST';
export const TERM_HOLIDAY_PERIOD_CREATE_SUCCESS = 'TERM_HOLIDAY_PERIOD_CREATE_SUCCESS';
export const TERM_HOLIDAY_PERIOD_CREATE_FAILURE = 'TERM_HOLIDAY_PERIOD_CREATE_FAILURE';

export const TERM_HOLIDAY_PERIOD_UPDATE_REQUEST = 'TERM_HOLIDAY_PERIOD_UPDATE_REQUEST';
export const TERM_HOLIDAY_PERIOD__UPDATE_SUCCESS = 'TERM_HOLIDAY_PERIOD_UPDATE_SUCCESS';
export const TERM_HOLIDAY_PERIOD_UPDATE_FAILURE = 'TERM_HOLIDAY_PERIOD_UPDATE_FAILURE';

export const TERM_HOLIDAY_DELETE_REQUEST = 'TERM_HOLIDAY_DELETE_REQUEST';
export const TERM_HOLIDAY_DELETE_SUCCESS = 'TERM_HOLIDAY_DELETE_SUCCESS';
export const TERM_HOLIDAY_DELETE_FAILURE = 'TERM_HOLIDAY_DELETE_FAILURE';

export const loadTermHolidayPeriods = ( options, termId ) => ({
	[CALL_API]: {
		types: [TERM_HOLIDAY_PERIODS_REQUEST, TERM_HOLIDAY_PERIODS_SUCCESS, TERM_HOLIDAY_PERIODS_FAILURE],
		endpoint: 'api/termHolidayPeriods',
		request: options,
		schema: Schemas.TERM_HOLIDAY_PERIOD_ARRAY
	},
	termId: termId
});

export const fetchTermHolidayPeriod = (id) => ({
	[CALL_API]: {
		types: [TERM_HOLIDAY_PERIOD_FETCH_REQUEST, TERM_HOLIDAY_PERIOD_FETCH_SUCCESS, TERM_HOLIDAY_PERIOD_FETCH_FAILURE],
		endpoint: `api/termHolidayPeriods/${id}`,
		schema: Schemas.TERM_HOLIDAY_PERIOD
	}
});

export const createTermHolidayPeriod = (termHolidayPeriod, history) => ({
	[CALL_API]: {
		types: [TERM_HOLIDAY_PERIOD_CREATE_REQUEST, TERM_HOLIDAY_PERIOD_CREATE_SUCCESS, TERM_HOLIDAY_PERIOD_CREATE_FAILURE],
		endpoint: 'api/termHolidayPeriods',
		method: 'POST',
		request: termHolidayPeriod,
		schema: Schemas.TERM_HOLIDAY_PERIOD,
		form: 'termHolidayPeriod',
		transition: {
			history,
			successPath: history.goBack
		}
	}
}); 

export const updateTermHolidayPeriod = (id, termHolidayPeriod) => ({
	[CALL_API]: {
		types: [TERM_HOLIDAY_PERIOD_UPDATE_REQUEST, TERM_HOLIDAY_PERIOD__UPDATE_SUCCESS, TERM_HOLIDAY_PERIOD_UPDATE_FAILURE],
		endpoint: `api/termHolidayPeriods/${id}`,
		method: 'PUT',
		request: termHolidayPeriod,
		schema: Schemas.TERM_HOLIDAY_PERIOD,
		form: 'termHolidayPeriod'
	}
});

export const deleteTermHoliday = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [TERM_HOLIDAY_DELETE_REQUEST, TERM_HOLIDAY_DELETE_SUCCESS, TERM_HOLIDAY_DELETE_FAILURE],
		endpoint: `api/termHolidayPeriods/${id}`,
		method: 'DELETE',
		onSuccessEvent
	}
});